import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic"
import LegacyThumbnail from "../legacyThumbnail/legacyThumbnail"
import Tag from "../tag/tag"

import { useStoryblokGlobalSettings } from "../../hooks/useStoryblokGlobalSettings"
import { buildInternalPath } from "../../helpers/URLHelpers"

import { formatArticleDate } from "../../helpers/dateHelper"


import styles from "./articleListingCard.module.scss"
import ArticleCardAuthorRow from "../articleCardComponents/articleCardAuthorRow"
import RouterLink from "../link/RouterLink";
import {articleUrlFromSlug} from "../../helpers/URLHelpers";
import { useCompressedImage } from "../storyblokImageBasic/helpers"

/// Layout options
// featured (Image above)
// inline (Image to the side)
// inlineSmall (Smaller image to the side)
// noImage (Just text)
function ArticleListingCard({ layout,
  titleSize = "default",
  slug,
  thumbnail,
  authors,
  title,
  summary,
  date,
  article_type,
  article_category,
  date_new_line,
  enable_comments,
  comment_count,
  enable_social_sharing,
  use_legacy_thumbnail_background,
  backgroundImage}) {
  const articleUrl = articleUrlFromSlug(slug)
  const globalSettings = useStoryblokGlobalSettings()

  let titleSizeClass = ''
  if (titleSize && titleSize !== "default") {
    titleSizeClass = `${styles[`textsize_${titleSize}`]}`;
  }

  if(!thumbnail || !thumbnail.filename) {
    thumbnail = globalSettings.thumbnail_default_image
  }
  const reorderTags = ["noImage","noImage_article_type","noImage_latest_news"].indexOf(layout) !== -1 ? true : false

  return (
    <article className={`${styles.articleAsideCard} ${styles[`layout_${layout}`]}`}>
      <div>
        <div className={styles.thumbnail}>
          {use_legacy_thumbnail_background ? (
            <LegacyThumbnail
              to={articleUrl}
              thumbnail_image={thumbnail}
              width={576} />
          ) : (
            <>
              {thumbnail && thumbnail.filename ? (
                <RouterLink to={buildInternalPath(articleUrl)} className={styles.defaultThumbnail}>
                  <StoryblokImageBasic width={576} image={thumbnail} />
                </RouterLink>
              ) : null}
            </>
          )}
        </div>
      </div>
      <div className={styles.content}
        style={{
          backgroundImage: backgroundImage ? `url('${useCompressedImage(backgroundImage.filename)}')` : '',
          backgroundSize: 'cover',
        }}>
        {!reorderTags ? renderTags(article_type, article_category, date, date_new_line) : null}
        {title ? (
          <RouterLink to={buildInternalPath(articleUrl)} className={`${styles.title} ${date_new_line ? styles.tagsAreAbove : ''}`}><h3 className={titleSizeClass}>{title}</h3></RouterLink>
        ) : null}
        {reorderTags ? renderTags(article_type, article_category, date, date_new_line) : null}
        {summary ? (
          <p className={styles.summary}>{summary}</p>
        ) : null}
        <ArticleCardAuthorRow className={styles.authorRow} withCommentsClassName={styles.comments} withShareClassName={styles.share} withAuthorClass={styles.author} whiteText={layout === 'spotlight'} authors={authors} enableComments={enable_comments} enableSocialSharing={enable_social_sharing} commentCount={comment_count} />
      </div>
    </article>
  )
}

function renderTags(article_type, article_category, date, dateNewLine) {
  return (
    <div className={styles.tagsAndDate}>
      <div className={styles.tags}>
        {article_type ? (
          <RouterLink to={buildInternalPath(article_type.slug)}>
            <Tag withClass={styles.tag} label={article_type.content.title} />
          </RouterLink>
        ) : null}
        {article_category ? (
          <RouterLink to={buildInternalPath(article_category.slug)}>
            <Tag withClass={styles.tag} label={article_category.content.title} />
          </RouterLink>
        ) : null}
      </div>
      {date ? (
        <div className={`${styles.date} ${dateNewLine ? styles.dateOwnLine : ""}`}>
          {formatArticleDate(date)}
        </div>
      ) : null}
    </div>
  )
}

export default ArticleListingCard
